var menu = (function ($) {

  var selectors = {
    document: document,
    body: 'body',
    nav: '.navbar-nav',
    account: '#accountItem',
    switcher: '#languageSwitcher'
  };
  var nodes;

  function mainNavigation() {
    nodes.account.appendTo(nodes.nav);
    nodes.switcher.appendTo(nodes.nav);
  }

  return {
    init: function () {
      nodes = utils.createNodes(selectors);
      mainNavigation();
    }
  };

})(jQuery);
